// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1zd_t","alert":"SettungsInbox_alert__3VQJ_"};